export const LABELS_LOAD = 'LABELS_LOAD';
export const LABEL_CREATE = 'LABEL_CREATE';
export const LABEL_RECREATE = 'LABEL_RECREATE';
export const LABEL_UPDATE = 'LABEL_UPDATE';
export const LABEL_DELETE = 'LABEL_DELETE';
export const LABEL_SELECT = 'LABEL_SELECT';